import * as z from 'zod';

export const companyPivotSchema = z.object({
  // FIX: PRODUCTION ISSUE
  client_id: z.number().nullish(),
  contact_id: z.number().nullish(),
  type: z.union([z.literal('primary'), z.literal('alternate')]),
});

export type ClientPivotSchema = z.infer<typeof companyPivotSchema>;
